export default function cartNotEmpty({ next, router, store }) {
  if (store.getters.cartSize === 0) {
    return router.replace("/cart");
  } else {
    next();
  }
}
